import LeafRectangleLoader from "../../../../../common/leaf/LeafLoadingSkeleton/LeafRectangleLoader/LeafRectangleLoader";
import "./IncomeBreakdownLoader.scss";

interface Props {
  isLoading: boolean;
  annual?: boolean;
}

export const IncomeBreakdownLoader = ({ isLoading, annual = false }: Props) => {
  if (annual) {
    return (
      <div className="IncomeBreakdownLoader IncomeBreakdownLoader--annual">
        <div>
          <LeafRectangleLoader isLoading={isLoading} numRows={1} width="16rem" height="1.5rem" margin="1.5rem 0 0 0" />
        </div>

        <LeafRectangleLoader isLoading={isLoading} styleClass="IncomeBreakdownLoader__estimated-income" />

        <div className="IncomeBreakdownLoader__tiles IncomeBreakdownLoader__tiles--annual">
          <div className="IncomeBreakdownLoader__tile IncomeBreakdownLoader__tile--annual">
            <LeafRectangleLoader isLoading={isLoading} numRows={1} width="100%" height="16rem" margin="0" />
          </div>
          <div className="IncomeBreakdownLoader__tile IncomeBreakdownLoader__tile--annual">
            <LeafRectangleLoader isLoading={isLoading} numRows={1} width="100%" height="16rem" margin="0" />
          </div>
          <div className="IncomeBreakdownLoader__tile IncomeBreakdownLoader__tile--annual">
            <LeafRectangleLoader isLoading={isLoading} numRows={1} width="100%" height="6.5rem" margin="0" />
          </div>
          <div className="IncomeBreakdownLoader__tile IncomeBreakdownLoader__tile--annual">
            <LeafRectangleLoader isLoading={isLoading} numRows={1} width="100%" height="6.5rem" margin="0" />
          </div>
          <div className="IncomeBreakdownLoader__tile IncomeBreakdownLoader__tile--annual">
            <LeafRectangleLoader isLoading={isLoading} numRows={1} width="100%" height="3.5rem" margin="0" />
          </div>
          <div className="IncomeBreakdownLoader__tile IncomeBreakdownLoader__tile--annual">
            <LeafRectangleLoader isLoading={isLoading} numRows={1} width="100%" height="3.5rem" margin="0" />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="IncomeBreakdownLoader__header">
        <LeafRectangleLoader isLoading={isLoading} numRows={1} width="16rem" height="1.5rem" margin="2.5rem 0 0 0" />
      </div>

      <LeafRectangleLoader isLoading={isLoading} styleClass="IncomeBreakdownLoader__estimated-income" />

      {/* CORE PLAN TILES */}
      <LeafRectangleLoader isLoading={isLoading} styleClass="IncomeBreakdownLoader__header" />

      <div className="income-breakdown__grid">
        <div className="income-breakdown__columnar">
          <div className="income-breakdown__columnar-left">
            <LeafRectangleLoader isLoading={isLoading} styleClass="IncomeBreakdownLoader__corePlanTile" />
          </div>
          <div className="income-breakdown__columnar-right">
            <LeafRectangleLoader isLoading={isLoading} styleClass="IncomeBreakdownLoader__corePlanTile" />
          </div>
        </div>
      </div>

      {/* CORE PLUS TILES */}
      <LeafRectangleLoader isLoading={isLoading} styleClass="IncomeBreakdownLoader__header" />

      <div className="income-breakdown__grid income-breakdown__grid--odd-count">
        <LeafRectangleLoader isLoading={isLoading} styleClass="IncomeBreakdownLoader__corePlusTile" />
        <LeafRectangleLoader isLoading={isLoading} styleClass="IncomeBreakdownLoader__corePlusTile" />
      </div>

      {/* NAV LINK TILES */}
      <div className="IncomeBreakdownLoader__navTiles">
        <LeafRectangleLoader isLoading={isLoading} styleClass="IncomeBreakdownLoader__navLinkTiles" />
        <LeafRectangleLoader isLoading={isLoading} styleClass="IncomeBreakdownLoader__navLinkTiles" />
        <LeafRectangleLoader isLoading={isLoading} styleClass="IncomeBreakdownLoader__navLinkTiles" />
      </div>
    </div>
  );
};
